import React from "react";
import CustomImageComponent from "./CustomImageComponent";

const Partner = (props) => {
  const { data } = props;
  return (
    <>
      {data && (
        <section
          className="partners-section"
          data-aos="fade-up"
          data-aos-duration="1500"
        >
          <div className="container">
            <h5 className="sub-title text-center">{data?.sectionTitle}</h5>
            <h2 className="title text-center">{data?.sectionHeader}</h2>
            <div className="row align-items-center custom-row">
              {data?.sectionItems?.length > 0 &&
                data.sectionItems.map((item, index) => (
                  <div
                    className="col-md-2 mb-3 mb-md-0 text-center logo-block"
                    key={index}
                  >
                    <CustomImageComponent
                      className={"img-fluid"}
                      src={item?.image ? `${item?.image}` : ""}
                      alt={item?.title || ""}
                    />
                  </div>
                ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Partner;
